import React from 'react';
import {
  Modal, View, StyleSheet, Text, TouchableOpacity, Pressable,
} from 'react-native';
import Style from '../../constants/Style';
import Colors from '../../constants/Colors';
import Button from '../Button';
import DeleteIcon24 from '../24pxIcons/DeleteIcon24';

interface LocationViewProps {
  hide: () => void,
  location: { name: string, highPriority: boolean, spaceCount?: number,
    assetCount: number, sensorCount?: number } | null,
  select: () => void,
  assetsSelected?: boolean,
}

const LocationView = ({
  hide, location, select, assetsSelected,
}: LocationViewProps) => (
    <Modal
      visible={!!location}
      transparent
      animationType='fade'
      presentationStyle='overFullScreen'
      onRequestClose={hide}
    >
      <View style={styles.overlay}>
        <Pressable style={StyleSheet.absoluteFill} onPress={hide} />
        {location ? (
          <View style={styles.container}>
            <Text style={styles.title}>{'Location info'}</Text>
            <View style={[styles.priorityLabel, location.highPriority && styles.highPriorityLabel]}>
              <Text style={[styles.priorityText, location.highPriority && styles.highPriorityText]}>
                {location.highPriority ? 'High' : 'Normal'}
              </Text>
            </View>
            <Text style={styles.areaName}>{location.name}</Text>
            <View style={Style.row}>
              <View style={styles.countSection}>
                <Text style={styles.countTitle}>{assetsSelected ? 'Assets:' : 'Sensors & Meters'}</Text>
                <Text style={styles.countValue}>
                  {assetsSelected ? location.assetCount : location.sensorCount}
                </Text>
              </View>
              {location.spaceCount ? (
                <View style={styles.countSection}>
                  <Text style={styles.countTitle}>{'Spaces:'}</Text>
                  <Text style={styles.countValue}>{location.spaceCount ?? '0'}</Text>
                </View>
              ) : null}
            </View>
            <Button
              style={styles.button}
              title='Go to location'
              onPress={select}
            />
            <TouchableOpacity
              style={Style.closeButtonBlack}
              onPress={hide}
            >
              <DeleteIcon24 color={Colors.light.hereworksBlack600} />
            </TouchableOpacity>
          </View>
        ) : null}
      </View>
    </Modal>
);

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: '#00000040',
  },
  container: {
    width: '100%',
    paddingTop: 16,
    paddingBottom: 32,
    paddingHorizontal: 24,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    backgroundColor: '#FFF',
  },
  title: {
    fontSize: 14,
    lineHeight: 17.5,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    alignSelf: 'center',
    textAlign: 'center',
    marginBottom: 31,
  },
  priorityLabel: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.light.hereworksGreen500,
    paddingHorizontal: 4,
    marginBottom: 8,
    alignSelf: 'flex-start',
  },
  priorityText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksGreen500,
  },
  highPriorityLabel: {
    borderColor: Colors.light.hereworksOrange500,
  },
  highPriorityText: {
    color: Colors.light.hereworksOrange500,
  },
  areaName: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    marginBottom: 24,
  },
  countSection: {
    flexDirection: 'row',
    flex: 1,
    paddingEnd: 12,
    alignItems: 'center',
  },
  countTitle: {
    fontSize: 14,
    lineHeight: 16,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack500,
    marginEnd: 8,
  },
  countValue: {
    fontSize: 14,
    lineHeight: 16,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack600,
  },
  button: {
    marginTop: 40,
    marginBottom: 32,
    alignSelf: 'stretch',
    minHeight: 40,
  },
});

export default LocationView;
